(ns dashboard.views.settings.spaces
  (:require
   [reagent.core :as reagent]
   [re-frame.core :as re-frame]
   [dashboard.i18n :refer [tr]]
   [dashboard.subs :as subs]
   [dashboard.events.spaces :as space-events]
   [dashboard.components.drawer :refer [drawer]]
   [dashboard.components.table :refer [table]]
   [dashboard.components.inputs :refer [input]]
   [dashboard.components.switch :refer [switch]]
   [dashboard.utils :refer [listen]]
   [dashboard.components.button :refer [button]]
   ["@heroicons/react/solid" :refer [CheckCircleIcon XIcon]]))

(defn- space-drawer-content [{:keys [state]}]
  [:div.relative.mt-6.flex-1.px-4.sm:px-6

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0
    [:div.flex.items-center
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      (tr :space/name)]]
    [:div.sm:col-span-3
     [input
      {:auto-complete "name"
       :name "name"
       :type "text"
       :disabled? (= (:action @state) :view)
       :default-value (get-in @state [:space :name])
       :on-change #(swap! state assoc-in [:space :name] %)}]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0.mt-2
    [:div.flex.items-center
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      (tr :space/nameJp)]]
    [:div.sm:col-span-3
     [input
      {:auto-complete "name"
       :name "name"
       :type "text"
       :disabled? (= (:action @state) :view)
       :default-value (get-in @state [:space :nameJp])
       :on-change #(swap! state assoc-in [:space :nameJp] %)}]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0.mt-2
    [:div.flex.items-center
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      (tr :space/boutiqueId)]]
    [:div.sm:col-span-3
     [input
      {:auto-complete "boutique-id"
       :name "boutique-id"
       :type "text"
       :disabled? (= (:action @state) :view)
       :default-value (get-in @state [:space :externalId])
       :on-change #(swap! state assoc-in [:space :externalId] %)}]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0.mt-4
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      (tr :space/active)]]
    [:div.sm:col-span-3
     [switch
      {:name "active"
       :checked? (get-in @state [:space :isActive])
       :on-change #(swap! state assoc-in [:space :isActive] (not (get-in @state [:space :isActive])))}]]]

   [:div.flex.flex-shrink-0.justify-end.py-4
    [button
     {:on-click #(do
                   (re-frame/dispatch
                    (case (:action @state)
                      :add [::space-events/create-space {:space (:space @state)}]
                      :delete [::space-events/delete-space {:space (:space @state)}]
                      :edit [::space-events/update-space {:space (:space @state)}]
                      ""))
                   (reset! state {:is-open? false
                                  :space nil
                                  :action nil}))}
     (case (:action @state)
       :add (tr :action/create)
       :delete (tr :action/delete)
       :edit (tr :action/save)
       "")]]])

(defn content []
  (let [drawer-state (reagent/atom {:is-open? false
                                    :space nil
                                    :action nil})]
    (fn []
      [:div
       ;; Add/Edit space drawer
       [drawer
        {:state drawer-state
         :title (case (:action @drawer-state)
                  :add (tr :action/add-fn (tr :space))
                  :delete (tr :action/delete-fn (tr :space))
                  :edit (tr :action/edit-fn (tr :space))
                  "")
         :content [space-drawer-content
                   {:state drawer-state}]}]

       [:div.px-4.pt-6
        [:div.sm:flex.sm:items-center
         [:div.sm:flex-auto]
         [:div.mt-4.sm:mt-0.sm:ml-16.sm:flex-none
          [button
           {:on-click #(reset! drawer-state
                               {:is-open? true
                                :space {:organizationId (str (:id (listen ::subs/organization)))
                                        :name ""
                                        :nameJp ""
                                        :timezone "Asia/Tokyo"
                                        :isActive true}
                                :action :add})}
           (tr :action/add-fn (tr :space))]]]]
       [:div.divide-y.divide-gray-200
        [:div.py-6.px-4.sm:p-6.lg:pb-8
         [table
          {:headers [{:title (tr :space/name)
                      :key :name
                      :render-cell (fn [name row]
                                     [:div.flex.flex-col
                                      [:span.font-semibold
                                       name]
                                      [:span.text-gray-500
                                       (:nameJp row)]])}
                     {:title (tr :space/boutiqueId)
                      :key :externalId
                      :render-cell (fn [external-id row]
                                     [:div.flex.flex-col
                                      [:span
                                       external-id]])}
                     {:title (tr :space/active)
                      :key :isActive
                      :class "w-12 whitespace-nowrap"
                      :render-cell (fn [active?]
                                     [:span.flex.justify-center
                                      (if active?
                                        [:> CheckCircleIcon
                                         {:class "h-5 w-5 text-success"
                                          :aria-hidden true}]
                                        [:> XIcon
                                         {:class "h-5 w-5 text-danger"
                                          :aria-hidden true}])])}]
           :rows (listen ::subs/spaces)
           :actions [{:name :edit
                      :text (tr :action/edit)
                      :on-click #(reset! drawer-state {:is-open? true
                                                       :space %
                                                       :action :edit})}
                     {:name :edit
                      :text (tr :action/delete)
                      :on-click #(reset! drawer-state {:is-open? true
                                                       :space %
                                                       :action :delete})}]}]]]])))
